import { useState } from "react";
import { columnsExtraResource } from "../../../../types/columnsTables/columnExtraResource";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import CardProjectFiche from "./CardProjectFiche";


const CardExtraResources = ({ isSuperAdmin, isAdmin, extraResources = [], activeModalDetailsProject, deleteRow }) => {
    const [isLoading, setIsLoading] = useState(false)

    const editForm = (e) => {
        activeModalDetailsProject(typeForDetailsProyect.hrsExtraResource, {
            type: 1,
            title: "Agregar recursos extra",
            dataForm: {
                ...e,
                type: e.typeextraresources,
                area: e.area || [],
                name: e.extraresources,
                startDate: e.dateStart,
                finishedDate: e.dateFinished,
            },
        });
    }

    const deleteData = async (key) => {
        setIsLoading(true)
        await deleteRow(typeForDetailsProyect.deleteExtraResoruce, { extraResourceId: key });
        setIsLoading(false)
    }

    const { columns: columnsExtraResources, props: tablePropsExtraResource } = columnsExtraResource(
        editForm,
        deleteData,
        { isSuperAdmin: isSuperAdmin }
    );
    return (
        <CardProjectFiche
            title="Horas recursos extras"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.hrsExtraResource, {
                            type: 0,
                            title: "Agregar recursos extra",
                        });
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="w-full">
                <TableGeneral
                    loading={isLoading}
                    column={columnsExtraResources}
                    state={extraResources}
                    pagination={{ position: ["topLeft", "topLeft"], pageSize: 5 }}
                    tableProps={tablePropsExtraResource}
                />
            </div>
        </CardProjectFiche>
    );
};

export default CardExtraResources;
